import { useEffect, useState } from "react";
import api from "@/lib/api";

const DEFAULTS = {
  instagram: "",
  youtube: "",
  whatsapp: "",
  email: "hello@anshagarwalfilms.com",
  location: "Mumbai · New Delhi · Worldwide",
};

export const whatsappHref = (digits) => (digits ? `https://wa.me/${digits}` : "");

export const prettyHandle = (url) => {
  if (!url) return "";
  try {
    const u = new URL(url);
    const path = u.pathname.replace(/\/+$/, "").split("/").filter(Boolean).pop() || u.hostname;
    return path.startsWith("@") ? path : `@${path}`;
  } catch {
    return url;
  }
};

export const prettyPhone = (digits) => {
  if (!digits) return "";
  if (digits.length === 12 && digits.startsWith("91")) return `+91 ${digits.slice(2, 7)} ${digits.slice(7)}`;
  return `+${digits}`;
};

export const useSettings = () => {
  const [settings, setSettings] = useState(DEFAULTS);
  useEffect(() => {
    api
      .get("/settings")
      .then((r) => setSettings({ ...DEFAULTS, ...r.data }))
      .catch(() => {});
  }, []);
  return settings;
};
